<script lang="ts">
    import type { PostsByCategoryQuery } from '$gen/graphql';
    import PostTeaser from '$lib/components/PostTeaser.svelte';
    import SeoMetaTags from '$lib/components/SeoMetaTags.svelte';
    import { mergePostAndSubmissionsByDate } from '$lib/post-and-submission-merge';
    import { isPostTeaserFragment, isSubmissionTeaserFragment } from '$lib/types/type-predicates';

    export let query: PostsByCategoryQuery;

    $: posts = query?.posts.filter(isPostTeaserFragment);
    $: submissions = query?.submissions.filter(isSubmissionTeaserFragment);
    $: mixedPosts = posts && submissions ? mergePostAndSubmissionsByDate(posts, submissions) : [];
    $: seo = query?.category?.__typename === 'postCategory_Category' ? query.category.seo : null;
</script>

<SeoMetaTags {seo} />

<section class="mb-5 grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
    {#each mixedPosts as post (post.id)}
        <PostTeaser {post} />
    {/each}
</section>
